import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './Shop.css';
import { LayoutComponent } from './component/Layout';
import { NotFoundPage } from './page/NotFound';
import { AboutPage } from './page/About';
import { CartPage } from './page/Cart';
import { CheckoutPage } from './page/Checkout';
import { HomePage } from './page/Home';
import { GoogleOAuthProvider } from '@react-oauth/google';

const Shop: React.FunctionComponent = () => {
  return (
    <GoogleOAuthProvider clientId="25477339145-vvsqcqtokrnt0nkgovg1cjmqc8dfc4uu.apps.googleusercontent.com">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LayoutComponent />}>
            <Route index element={<HomePage />} />
            <Route path="cart" element={<CartPage />} />
            <Route path="checkout" element={<CheckoutPage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="layout" element={<LayoutComponent />}>
              <Route index element={<AboutPage />} />
              <Route path=":number" element={<AboutPage />} />
            </Route>
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </GoogleOAuthProvider>
  );
};

export { Shop };
